import { createBrowserRouter } from 'react-router'
import Layout from '../components/Layout'
import ErrorBoundary from '../pages/ErrorBoundary'
import Home from '../pages/home/Home'
import homeLoader from '../pages/home/homeLoader'
import NotFound from '../pages/NotFound'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <ErrorBoundary />,
    children: [
      // {
      //   index: true, // 根路径重定向到文章列表
      //   loader: () => {
      //     // eslint-disable-next-line @typescript-eslint/only-throw-error
      //     throw new Response(null, { status: 302, headers: { Location: '/posts' } })
      //   },
      // },
      {
        index: true,
        element: <Home />,
        loader: homeLoader,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
])

export default router
